import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import ManageContactsSidebar from "./PhoneManagementSidebar";

const ManagePhone = () => {
  return (
    <div className="h-screen flex overflow-hidden bg-gray-50">

      {/* Main App Sidebar */}
      <div className="h-full">
        <Sidebar />
      </div>

      {/* Phone Management Sidebar */}
      <div className="h-full border-r border-gray-200">
        <ManageContactsSidebar />
      </div>

      {/* Scrollable Content Area */}
      <div className="flex-1 h-full overflow-y-auto p-8">
        <Outlet />
      </div>

    </div>
  );
};

export default ManagePhone;